// ===========================================================================
// What each emoji in the picker is called, so the picker can be searched
// (the operator, 2026-10-07: "I want to be able to search the emoji list").
//
// Keyed by the first code point, in hex. The words are the Unicode character
// name (Unicode 15.1, lower case) with the everyday words people actually type
// added after it ("lol", "love", "sad", "thumbs up"). Generated once from the
// Unicode names; a new emoji in EMOJI_GROUPS needs a line here, which the
// test that counts them says. English only: the catalogs translate the
// interface, not these. ASCII only.
// ===========================================================================

export const EMOJI_NAMES = Object.freeze({
  '1f600': 'grinning face happy smile grin',
  '1f603': 'smiling face with open mouth happy smile',
  '1f604': 'smiling face with open mouth and smiling eyes happy smile laugh',
  '1f601': 'grinning face with smiling eyes happy grin',
  '1f606': 'smiling face with open mouth and tightly-closed eyes laugh haha',
  '1f605': 'smiling face with open mouth and cold sweat sweat nervous awkward phew',
  '1f923': 'rolling on the floor laughing lol rofl laugh haha funny',
  '1f602': 'face with tears of joy lol laugh crying funny haha joy',
  '1f642': 'slightly smiling face smile happy',
  '1f643': 'upside-down face upside down silly sarcastic',
  '1f609': 'winking face wink',
  '1f60a': 'smiling face with smiling eyes smile happy blush',
  '1f607': 'smiling face with halo angel innocent halo',
  '1f970': 'smiling face with smiling eyes and three hearts love hearts adore crush',
  '1f60d': 'smiling face with heart-shaped eyes love heart eyes crush',
  '1f929': 'grinning face with star eyes star struck wow amazing',
  '1f618': 'face throwing a kiss kiss love',
  '1f617': 'kissing face kiss',
  '1f61a': 'kissing face with closed eyes kiss',
  '1f619': 'kissing face with smiling eyes kiss',
  '1f60b': 'face savouring delicious food yum tasty delicious',
  '1f61b': 'face with stuck-out tongue tongue silly',
  '1f61c': 'face with stuck-out tongue and winking eye tongue wink silly crazy',
  '1f92a': 'grinning face with one large and one small eye crazy silly zany',
  '1f61d': 'face with stuck-out tongue and tightly-closed eyes tongue silly',
  '1f911': 'money-mouth face money rich',
  '1f917': 'hugging face hug hugs',
  '1f92d': 'smiling face with smiling eyes and hand covering mouth oops giggle',
  '1f92b': 'face with finger covering closed lips shh quiet secret',
  '1f914': 'thinking face think hmm wonder',
  '1f910': 'zipper-mouth face zip quiet secret',
  '1f928': 'face with one eyebrow raised eyebrow suspicious skeptical',
  '1f610': 'neutral face meh neutral',
  '1f611': 'expressionless face meh blank',
  '1f636': 'face without mouth speechless',
  '1f60f': 'smirking face smirk',
  '1f612': 'unamused face unamused meh annoyed',
  '1f644': 'face with rolling eyes eye roll whatever annoyed',
  '1f62c': 'grimacing face grimace awkward eek',
  '1f925': 'lying face lie liar',
  '1f60c': 'relieved face relieved calm',
  '1f614': 'pensive face sad pensive',
  '1f62a': 'sleepy face sleepy tired',
  '1f924': 'drooling face drool',
  '1f634': 'sleeping face sleep tired zzz',
  '1f637': 'face with medical mask mask sick',
  '1f912': 'face with thermometer sick ill fever',
  '1f915': 'face with head-bandage hurt injured',
  '1f922': 'nauseated face sick nauseous gross',
  '1f92e': 'face with open mouth vomiting vomit sick gross puke',
  '1f927': 'sneezing face sneeze sick',
  '1f975': 'overheated face hot sweating',
  '1f976': 'freezing face cold freezing',
  '1f974': 'face with uneven eyes and wavy mouth woozy dizzy drunk',
  '1f635': 'dizzy face dizzy',
  '1f92f': 'shocked face with exploding head mind blown wow',
  '1f920': 'face with cowboy hat cowboy',
  '1f973': 'face with party horn and party hat party birthday celebrate',
  '1f60e': 'smiling face with sunglasses cool sunglasses',
  '1f913': 'nerd face nerd geek',
  '1f9d0': 'face with monocle monocle curious',
  '1f615': 'confused face confused',
  '1f61f': 'worried face worried',
  '1f641': 'slightly frowning face sad frown',
  '1f62e': 'face with open mouth wow surprised',
  '1f62f': 'hushed face surprised',
  '1f632': 'astonished face shocked astonished wow',
  '1f633': 'flushed face flushed embarrassed omg',
  '1f97a': 'face with pleading eyes please puppy eyes pleading',
  '1f626': 'frowning face with open mouth frown',
  '1f627': 'anguished face anguished',
  '1f628': 'fearful face scared fear',
  '1f630': 'face with open mouth and cold sweat anxious nervous sweat',
  '1f625': 'disappointed but relieved face sad relieved',
  '1f622': 'crying face sad cry tear',
  '1f62d': 'loudly crying face cry sob sad tears',
  '1f631': 'face screaming in fear scream shock omg scared',
  '1f616': 'confounded face confounded',
  '1f623': 'persevering face persevere',
  '1f61e': 'disappointed face sad disappointed',
  '1f613': 'face with cold sweat sweat',
  '1f629': 'weary face weary tired',
  '1f62b': 'tired face tired',
  '1f971': 'yawning face yawn tired bored',
  '1f624': 'face with look of triumph triumph huff',
  '1f621': 'pouting face angry mad rage',
  '1f620': 'angry face angry mad',
  '1f92c': 'serious face with symbols covering mouth swear cursing angry',
  '1f608': 'smiling face with horns devil evil',
  '1f47f': 'imp devil angry',
  '1f480': 'skull skull dead lol',
  '1f4a9': 'pile of poo poop',
  '1f921': 'clown face clown',
  '1f47b': 'ghost ghost boo',
  '1f47d': 'extraterrestrial alien alien',
  '1f916': 'robot face robot',
  '1f63a': 'smiling cat face with open mouth cat happy',
  '1f638': 'grinning cat face with smiling eyes cat',
  '1f639': 'cat face with tears of joy cat lol',
  '1f63b': 'smiling cat face with heart-shaped eyes cat love',
  '1f63c': 'cat face with wry smile cat',
  '1f63d': 'kissing cat face with closed eyes cat kiss',
  '1f640': 'weary cat face cat scared',
  '1f63f': 'crying cat face cat sad',
  '1f63e': 'pouting cat face cat angry',
  '1f44b': 'waving hand sign wave hi hello bye',
  '1f91a': 'raised back of hand',
  '1f590': 'raised hand with fingers splayed',
  '270b': 'raised hand stop high five',
  '1f596': 'raised hand with part between middle and ring fingers',
  '1f44c': 'ok hand sign ok okay perfect',
  '1f90c': 'pinched fingers',
  '1f90f': 'pinching hand',
  '270c': 'victory hand peace victory',
  '1f91e': 'hand with index and middle fingers crossed fingers crossed luck hope',
  '1f91f': 'i love you hand sign love you',
  '1f918': 'sign of the horns rock horns',
  '1f919': 'call me hand call me shaka',
  '1f448': 'white left pointing backhand index left point',
  '1f449': 'white right pointing backhand index right point',
  '1f446': 'white up pointing backhand index up point',
  '1f447': 'white down pointing backhand index down point',
  '261d': 'white up pointing index up point',
  '1f44d': 'thumbs up sign thumbs up yes ok like good',
  '1f44e': 'thumbs down sign thumbs down no dislike bad',
  '270a': 'raised fist fist',
  '1f44a': 'fisted hand sign fist bump punch',
  '1f91b': 'left-facing fist',
  '1f91c': 'right-facing fist',
  '1f44f': 'clapping hands sign clap applause bravo',
  '1f64c': 'person raising both hands in celebration hooray celebrate yay',
  '1f450': 'open hands sign',
  '1f932': 'palms up together palms',
  '1f91d': 'handshake handshake deal agree',
  '1f64f': 'person with folded hands please pray thanks thank you',
  '270d': 'writing hand',
  '1f485': 'nail polish nails',
  '1f933': 'selfie selfie',
  '1f4aa': 'flexed biceps strong muscle flex gym',
  '1f9b5': 'leg',
  '1f442': 'ear',
  '1f443': 'nose',
  '1f440': 'eyes eyes look see',
  '1f441': 'eye',
  '1f445': 'tongue tongue',
  '1f444': 'mouth lips mouth',
  '1f9e0': 'brain brain smart',
  '1f476': 'baby baby',
  '1f9d2': 'child',
  '1f466': 'boy boy',
  '1f467': 'girl girl',
  '1f9d1': 'adult',
  '1f468': 'man man',
  '1f469': 'woman woman',
  '1f9d3': 'older adult',
  '1f474': 'older man',
  '1f475': 'older woman',
  '1f46e': 'police officer police cop',
  '1f477': 'construction worker',
  '1f478': 'princess princess',
  '1f934': 'prince prince',
  '1f470': 'bride with veil bride wedding',
  '1f935': 'man in tuxedo',
  '1f9b8': 'superhero superhero hero',
  '1f9b9': 'supervillain',
  '1f9d9': 'mage wizard magic',
  '1f9da': 'fairy',
  '1f9dd': 'elf',
  '1f483': 'dancer dance dancing',
  '1f57a': 'man dancing dance dancing',
  '1f46b': 'man and woman holding hands',
  '1f46c': 'two men holding hands',
  '1f46d': 'two women holding hands',
  '1f48f': 'kiss kiss couple',
  '1f491': 'couple with heart couple love',
  '1f46a': 'family family',
  '1f5e3': 'speaking head in silhouette',
  '1f464': 'bust in silhouette',
  '1f465': 'busts in silhouette',
  '2764': 'heavy black heart love heart red',
  '1f9e1': 'orange heart heart love orange',
  '1f49b': 'yellow heart heart love yellow',
  '1f49a': 'green heart heart love green',
  '1f499': 'blue heart heart love blue',
  '1f49c': 'purple heart heart love purple',
  '1f90e': 'brown heart heart love brown',
  '1f5a4': 'black heart heart love black',
  '1f90d': 'white heart heart love white',
  '1f494': 'broken heart heartbreak sad broken',
  '2763': 'heavy heart exclamation mark ornament',
  '1f495': 'two hearts love hearts',
  '1f49e': 'revolving hearts love hearts',
  '1f493': 'beating heart love heartbeat',
  '1f497': 'growing heart love heart',
  '1f496': 'sparkling heart love heart sparkle',
  '1f498': 'heart with arrow love heart cupid',
  '1f49d': 'heart with ribbon love heart gift',
  '1f49f': 'heart decoration',
  '262e': 'peace symbol peace',
  '1f4af': 'hundred points symbol hundred perfect 100',
  '1f4a2': 'anger symbol',
  '1f4a5': 'collision symbol boom bang',
  '1f4ab': 'dizzy symbol dizzy star',
  '1f4a6': 'splashing sweat symbol',
  '1f4a8': 'dash symbol',
  '1f4ac': 'speech balloon chat speech talk',
  '1f4ad': 'thought balloon',
  '1f4a4': 'sleeping symbol sleep zzz',
  '2728': 'sparkles sparkles shiny magic',
  '2b50': 'white medium star star',
  '1f31f': 'glowing star star glow',
  '26a1': 'high voltage sign lightning zap',
  '1f525': 'fire fire lit hot',
  '1f308': 'rainbow rainbow pride',
  '2705': 'white heavy check mark yes check done ok',
  '274c': 'cross mark no cross wrong',
  '2753': 'black question mark ornament question what',
  '2757': 'heavy exclamation mark symbol exclamation important',
  '203c': 'double exclamation mark',
  '2049': 'exclamation question mark',
  '1f51e': 'no one under eighteen symbol',
  '1f4f5': 'no mobile phones',
  '1f3b5': 'musical note music song note',
  '1f3b6': 'multiple musical notes music song notes',
  '1f4a1': 'electric light bulb idea light bulb',
  '1f436': 'dog face dog puppy',
  '1f431': 'cat face cat kitty',
  '1f42d': 'mouse face mouse',
  '1f439': 'hamster face',
  '1f430': 'rabbit face bunny rabbit',
  '1f98a': 'fox face fox',
  '1f43b': 'bear face bear',
  '1f43c': 'panda face panda',
  '1f428': 'koala',
  '1f42f': 'tiger face',
  '1f981': 'lion face lion',
  '1f42e': 'cow face',
  '1f437': 'pig face pig',
  '1f438': 'frog face frog',
  '1f435': 'monkey face monkey',
  '1f412': 'monkey',
  '1f414': 'chicken',
  '1f427': 'penguin',
  '1f426': 'bird',
  '1f424': 'baby chick',
  '1f986': 'duck',
  '1f985': 'eagle',
  '1f989': 'owl',
  '1f987': 'bat',
  '1f43a': 'wolf face',
  '1f417': 'boar',
  '1f434': 'horse face',
  '1f984': 'unicorn face unicorn',
  '1f41d': 'honeybee bee',
  '1f41b': 'bug',
  '1f98b': 'butterfly butterfly',
  '1f40c': 'snail',
  '1f41e': 'lady beetle',
  '1f41c': 'ant',
  '1f422': 'turtle turtle',
  '1f40d': 'snake snake',
  '1f98e': 'lizard',
  '1f419': 'octopus octopus',
  '1f991': 'squid',
  '1f990': 'shrimp',
  '1f980': 'crab',
  '1f421': 'blowfish',
  '1f420': 'tropical fish',
  '1f41f': 'fish',
  '1f42c': 'dolphin dolphin',
  '1f433': 'spouting whale whale',
  '1f40b': 'whale',
  '1f988': 'shark shark',
  '1f40a': 'crocodile',
  '1f405': 'tiger',
  '1f406': 'leopard',
  '1f993': 'zebra face',
  '1f98d': 'gorilla',
  '1f418': 'elephant',
  '1f98f': 'rhinoceros',
  '1f42a': 'dromedary camel',
  '1f42b': 'bactrian camel',
  '1f992': 'giraffe face',
  '1f998': 'kangaroo',
  '1f411': 'sheep',
  '1f410': 'goat',
  '1f98c': 'deer',
  '1f415': 'dog dog',
  '1f429': 'poodle',
  '1f408': 'cat cat',
  '1f413': 'rooster',
  '1f983': 'turkey',
  '1f54a': 'dove of peace',
  '1f407': 'rabbit',
  '1f43f': 'chipmunk',
  '1f409': 'dragon dragon',
  '1f432': 'dragon face dragon',
  '1f335': 'cactus',
  '1f384': 'christmas tree',
  '1f332': 'evergreen tree',
  '1f333': 'deciduous tree',
  '1f334': 'palm tree',
  '1f331': 'seedling',
  '1f33f': 'herb',
  '2618': 'shamrock',
  '1f340': 'four leaf clover',
  '1f341': 'maple leaf',
  '1f342': 'fallen leaf',
  '1f343': 'leaf fluttering in wind',
  '1f33a': 'hibiscus',
  '1f33b': 'sunflower sunflower flower',
  '1f33c': 'blossom',
  '1f337': 'tulip tulip flower',
  '1f338': 'cherry blossom blossom flower',
  '1f339': 'rose rose flower',
  '1f33e': 'ear of rice',
  '1f30d': 'earth globe europe-africa earth world globe',
  '1f30e': 'earth globe americas',
  '1f30f': 'earth globe asia-australia',
  '1f311': 'new moon symbol',
  '1f315': 'full moon symbol',
  '1f319': 'crescent moon moon night',
  '1f31e': 'sun with face sun',
  '2600': 'black sun with rays sun sunny',
  '26c5': 'sun behind cloud',
  '2601': 'cloud',
  '1f327': 'cloud with rain',
  '26c8': 'thunder cloud and rain',
  '1f328': 'cloud with snow',
  '2744': 'snowflake snow cold',
  '26c4': 'snowman without snow snowman',
  '1f32c': 'wind blowing face',
  '1f30a': 'water wave wave ocean sea',
  '1f34f': 'green apple',
  '1f34e': 'red apple',
  '1f34a': 'tangerine',
  '1f34b': 'lemon',
  '1f34c': 'banana',
  '1f349': 'watermelon',
  '1f347': 'grapes',
  '1f353': 'strawberry',
  '1f352': 'cherries',
  '1f351': 'peach',
  '1f34d': 'pineapple',
  '1f95d': 'kiwifruit',
  '1f345': 'tomato',
  '1f965': 'coconut',
  '1f951': 'avocado',
  '1f346': 'aubergine',
  '1f955': 'carrot',
  '1f33d': 'ear of maize',
  '1f336': 'hot pepper',
  '1f954': 'potato',
  '1f35e': 'bread',
  '1f9c0': 'cheese wedge',
  '1f95a': 'egg',
  '1f373': 'cooking',
  '1f953': 'bacon',
  '1f357': 'poultry leg',
  '1f354': 'hamburger burger hamburger',
  '1f35f': 'french fries fries chips',
  '1f355': 'slice of pizza pizza',
  '1f32d': 'hot dog',
  '1f96a': 'sandwich',
  '1f32e': 'taco',
  '1f32f': 'burrito',
  '1f957': 'green salad',
  '1f35d': 'spaghetti',
  '1f35c': 'steaming bowl',
  '1f363': 'sushi',
  '1f371': 'bento box',
  '1f35a': 'cooked rice',
  '1f358': 'rice cracker',
  '1f359': 'rice ball',
  '1f362': 'oden',
  '1f366': 'soft ice cream',
  '1f368': 'ice cream',
  '1f370': 'shortcake cake',
  '1f382': 'birthday cake cake birthday',
  '1f36b': 'chocolate bar chocolate',
  '1f36c': 'candy',
  '1f36d': 'lollipop',
  '1f369': 'doughnut donut doughnut',
  '1f36a': 'cookie cookie',
  '1f37f': 'popcorn popcorn movie',
  '2615': 'hot beverage coffee tea hot drink',
  '1f375': 'teacup without handle tea',
  '1f9c3': 'beverage box',
  '1f964': 'cup with straw',
  '1f9cb': 'bubble tea boba bubble tea',
  '1f37a': 'beer mug beer drink cheers',
  '1f377': 'wine glass wine',
  '1f378': 'cocktail glass',
  '1f379': 'tropical drink',
  '1f942': 'clinking glasses cheers toast drink',
  '26bd': 'soccer ball football soccer',
  '1f3c0': 'basketball and hoop basketball',
  '1f3c8': 'american football football american',
  '26be': 'baseball',
  '1f3be': 'tennis racquet and ball',
  '1f3d0': 'volleyball',
  '1f3c9': 'rugby football',
  '1f3b1': 'billiards',
  '1f3d3': 'table tennis paddle and ball',
  '1f3f8': 'badminton racquet and shuttlecock',
  '1f945': 'goal net',
  '26f3': 'flag in hole',
  '1f3f9': 'bow and arrow',
  '1f3a3': 'fishing pole and fish',
  '1f94a': 'boxing glove',
  '1f3bf': 'ski and ski boot',
  '1f6f7': 'sled',
  '1f3c2': 'snowboarder',
  '1f3c4': 'surfer',
  '1f6a3': 'rowboat',
  '1f3ca': 'swimmer',
  '1f6b4': 'bicyclist',
  '1f3c6': 'trophy trophy win winner',
  '1f947': 'first place medal gold first winner',
  '1f948': 'second place medal',
  '1f949': 'third place medal',
  '1f3ab': 'ticket',
  '1f3ad': 'performing arts',
  '1f3a8': 'artist palette art paint',
  '1f3ac': 'clapper board movie film',
  '1f3a4': 'microphone mic sing karaoke',
  '1f3a7': 'headphone headphones music',
  '1f3b8': 'guitar guitar music',
  '1f3b9': 'musical keyboard',
  '1f3ba': 'trumpet',
  '1f3bb': 'violin',
  '1f941': 'drum with drumsticks',
  '1f3ae': 'video game game gaming controller video game',
  '1f579': 'joystick',
  '1f3b2': 'game die',
  '1f9e9': 'jigsaw puzzle piece',
  '265f': 'black chess pawn',
  '1f697': 'automobile car',
  '1f695': 'taxi',
  '1f68c': 'bus',
  '1f3ce': 'racing car',
  '1f3cd': 'racing motorcycle',
  '1f6b2': 'bicycle',
  '1f6f5': 'motor scooter',
  '1f6a8': 'police cars revolving light',
  '1f682': 'steam locomotive',
  '1f686': 'train',
  '2708': 'airplane plane travel flight',
  '1f680': 'rocket rocket space',
  '1f6f8': 'flying saucer',
  '26f5': 'sailboat',
  '1f6a2': 'ship',
  '1f3e0': 'house building house home',
  '1f3e2': 'office building',
  '1f3e5': 'hospital',
  '1f3eb': 'school school',
  '1f3f0': 'european castle',
  '1f5fc': 'tokyo tower',
  '1f5fd': 'statue of liberty',
  '1f3d6': 'beach with umbrella',
  '1f3dd': 'desert island',
  '26fa': 'tent',
  '1f3d5': 'camping',
  '1f3d4': 'snow capped mountain',
  '1f303': 'night with stars',
  '1f309': 'bridge at night',
  '1f386': 'fireworks',
  '231a': 'watch',
  '1f4f1': 'mobile phone phone mobile',
  '1f4bb': 'personal computer laptop computer',
  '2328': 'keyboard',
  '1f5a8': 'printer',
  '1f4f7': 'camera camera photo',
  '1f4f8': 'camera with flash',
  '1f4f9': 'video camera',
  '1f3a5': 'movie camera',
  '1f4fa': 'television',
  '1f4fb': 'radio',
  '1f4fc': 'videocassette',
  '1f4bf': 'optical disc',
  '1f4be': 'floppy disk',
  '1f4bd': 'minidisc',
  '1f4d5': 'closed book',
  '1f4d6': 'open book',
  '1f4da': 'books books study',
  '1f4dd': 'memo note write',
  '1f4f0': 'newspaper',
  '1f4c5': 'calendar',
  '1f4cc': 'pushpin',
  '1f4ce': 'paperclip',
  '1f4cf': 'straight ruler',
  '1f4d0': 'triangular ruler',
  '1f4d2': 'ledger',
  '1f4d3': 'notebook',
  '2702': 'black scissors',
  '1f512': 'lock',
  '1f513': 'open lock',
  '1f511': 'key',
  '1f528': 'hammer',
  '1f527': 'wrench',
  '1f529': 'nut and bolt',
  '1f52c': 'microscope',
  '1f52d': 'telescope',
  '1f526': 'electric torch',
  '1f56f': 'candle',
  '1f4b0': 'money bag money',
  '1f4b3': 'credit card',
  '1f48e': 'gem stone diamond gem',
  '1f381': 'wrapped present gift present birthday',
  '1f388': 'balloon balloon party',
  '1f389': 'party popper party celebrate congrats tada',
  '1f38a': 'confetti ball party confetti',
  '1f380': 'ribbon',
  '1f9f8': 'teddy bear',
  '1f9f9': 'broom',
  '1f9fa': 'basket',
  '1f6cf': 'bed',
  '1f6bf': 'shower',
  '1f6c1': 'bathtub',
  '1f9f4': 'lotion bottle',
  '1f9fc': 'bar of soap',
  '1f393': 'graduation cap graduation school',
  '1f451': 'crown crown king queen',
  '1f452': 'womans hat',
  '1f3a9': 'top hat',
  '1f392': 'school satchel',
  '1f45c': 'handbag',
  '1f45d': 'pouch',
  '1f45e': 'mans shoe',
  '1f45f': 'athletic shoe',
  '1f460': 'high-heeled shoe',
  '1f461': 'womans sandal',
  '1f462': 'womans boots',
  '1f97e': 'hiking boot',
  '1f97f': 'flat shoe',
  '1f455': 't-shirt',
  '1f456': 'jeans',
  '1f457': 'dress',
  '1f458': 'kimono',
  '1f459': 'bikini',
  '1f45a': 'womans clothes',
  '1f9e3': 'scarf',
  '1f9e4': 'gloves',
  '1f9e5': 'coat',
  '1f9e6': 'socks',
  '1f48d': 'ring ring engagement',
  '1f48c': 'love letter love letter',
  '1f4e3': 'cheering megaphone',
  '1f4ef': 'postal horn',
  '1f4e2': 'public address loudspeaker',
  '1f514': 'bell bell notification',
});

export default { EMOJI_NAMES };
